import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Close';

interface ClassTimeFilterModalProps {
  isOpen: boolean;
  closeFilter: () => void;
  applyFilter: (filterId: string, option: string) => void;
  appliedFilter: string | undefined;
  anchorEl: HTMLElement | null;
}

const CLASS_TIME_OPTIONS = ['Sáng <12h', 'Chiều <22h'];

const ClassTimeFilterModal: React.FC<ClassTimeFilterModalProps> = ({
  isOpen,
  closeFilter,
  applyFilter,
  appliedFilter,
  anchorEl,
}) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (anchorEl && isOpen) {
      const rect = anchorEl.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 8,
        left: rect.left,
      });
    }
  }, [anchorEl, isOpen]);

  const handleClose = () => {
    closeFilter();
  };

  const handleOptionClick = (option: string) => {
    applyFilter('classTime', option);
    handleClose();
  };

  return (
    <AnimatePresence>
      {isOpen && anchorEl && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: -10 }}
          transition={{ duration: 0.2 }}
          style={{
            position: 'fixed',
            top: `${position.top}px`,
            left: `${position.left}px`,
            zIndex: 1000,
          }}
          data-filter-modal
          className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 w-56"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-sm font-bold text-gray-900 dark:text-gray-100">
              Chọn Ca Học
            </h2>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-1"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>

          <div className="space-y-1 p-2 max-h-64 overflow-y-auto">
            {CLASS_TIME_OPTIONS.map((time) => (
              <motion.button
                key={time}
                whileHover={{ x: 2 }}
                onClick={() => handleOptionClick(time)}
                className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${
                  appliedFilter === time
                    ? 'bg-[#017e6e] text-white font-medium'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
              >
                {time}
              </motion.button>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ClassTimeFilterModal;
